module.exports = __webpack_public_path__ + "static/media/vibino-feature-Transparent-pic6.b24486b5.jpg";